import React from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import {parsePlayerPointsValue} from 'helpers/number-helper';
import {PlayerPoints} from './index';
import NumberHelper from 'helpers/number-helper';

class FlexRankPlayerPoints extends PlayerPoints {
    onBlur(value) {
        const player = this.getPlayer();

        if (!player) {
            return;
        }

        const correctValue = parsePlayerPointsValue(value);

        this.onChange(correctValue);
        this.isValueBeingChanged = false;

        this.updateUserPoints(player, correctValue);

        this.resetPlayerSympathy();
    }

    updateUserPoints(player, value) {
        const {modesConfig, propName} = this.props;

        modesConfig.all({asArr: true}).map((modeConfig) => {
            let userPoints = modeConfig.getPointCoefficient() * value;
            userPoints = NumberHelper.float(userPoints, 3);

            this.props.dispatch(
                Action.set(
                    'UserPoints',
                    [
                        {
                            playerId: player.getId(),
                            [propName]: userPoints,
                        },
                    ],
                    modeConfig.getRole(),
                ),
            );
        });
    }

    resetPlayerSympathy() {
        const {modesConfig, playerId} = this.props;

        const playerSympathyByMode = {};
        modesConfig.all({asArr: true}).map((modeConfig) => {
            playerSympathyByMode[modeConfig.getRole()] = {
                [playerId]: null,
            };
        });

        this.props.dispatch(Action.set('PlayersSympathy', playerSympathyByMode));
    }

    getMode() {
        return Const.FLEX_MODE;
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {players},
        userPointsType,
        modesConfig,
    } = state;

    return {
        players,
        userPointsType,
        modesConfig,
    };
}

export default connect(mapStatesToProps)(FlexRankPlayerPoints);
